import { Mapper } from "../../../../base/utils/mapper";
import { AttentionStateModel } from "../../../../domain/models/consult/attention-state.model";
import { AttentionStateEntity } from "../entities/attention-state.entity";

export class AttentionStateImplementationRepositoryMapper extends Mapper<AttentionStateEntity, AttentionStateModel> {
    mapFrom(param: AttentionStateEntity): AttentionStateModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: AttentionStateModel): AttentionStateEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}
